import { Helmet } from 'react-helmet-async'

export default function SEOHead({ title, description, ogTitle, ogDescription, ogImage, canonicalUrl }) {
  const pageTitle = title?.includes('Casper') ? title : `${title ? `${title} — ` : ''}Casper DJ`
  const defaultDesc = 'Planlægger du at leje en DJ til din næste fest? CasperDJ kører ud til både private fester, bryllupper og firmaevents.'
  const desc = description || ogDescription || defaultDesc
  const defaultOgImage = 'https://assets.auxodev.dk/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/logo_1a594eb3.png'
  const image = ogImage || defaultOgImage

  return (
    <Helmet>
      <html lang="da" />
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={ogTitle || pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || pageTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
